// /var/www/afra/192.testproject.work/maracar8/0.8.2/myapp/src/utils/dateUtils.js

export const getSelectedDate = (selectedDate) => {
    return selectedDate || new Date().toISOString().slice(0, 10);
  };
  